import React from 'react';
import { Button, Box, Text as Typography } from '@liquid-spirit/ui-web';
import { IoSearchOutline } from 'react-icons/io5';
import './DetailEmptyState.less';

const DetailEmptyState = ({
  contextLabel = 'Details',
  title,
  message,
  actionLabel = 'Browse',
  onAction,
  icon = <IoSearchOutline size={34} />,
}) => (
  <Box className="detail-empty-state">
    <Box className="detail-empty-state__icon" aria-hidden="true">
      {icon}
    </Box>
    <Box className="detail-empty-state__eyebrow">
      <Typography variant="overline">{contextLabel}</Typography>
    </Box>
    <Typography variant="h4" className="detail-empty-state__title">
      {title}
    </Typography>
    <Typography variant="body1" className="detail-empty-state__message">
      {message}
    </Typography>
    <Box className="detail-empty-state__actions">
      <Button
        primary
        label={actionLabel}
        onClick={onAction}
        type="button"
      />
    </Box>
  </Box>
);

export default DetailEmptyState;
